<div class="input">
  @if (label(); as labelText) {
    <!-- Making sure there is no whitespace between labelText and dmb-help-button -->
    <!-- eslint-disable -->
    <label [for]="id"
      >{{ labelText
      }}@if (helpText(); as hText) {
        <dmb-help-button [text]="hText" />
      }
    </label>
    <!-- eslint-enable -->
  }
  <div>
    <div class="prefix-content"><ng-content select="[prefix]" /></div>

    @if (autoComplete(); as autoC) {
      <input
        #theInput
        [id]="id"
        [value]="value()"
        (input)="value.set($event.target.value)"
        (blur)="blurred.emit($event)"
        [class.hasError]="hasError()"
        [matAutocomplete]="autoC"
        [attr.name]="name()"
        [attr.placeholder]="placeholder()"
        [type]="type()"
        [required]="required()"
        [readOnly]="readOnly()"
        [disabled]="disabled()"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.step]="step()" />
    } @else {
      <input
        #theInput
        [id]="id"
        [value]="value()"
        (input)="value.set($event.target.value)"
        (blur)="blurred.emit($event)"
        [class.hasError]="hasError()"
        [attr.name]="name()"
        [attr.placeholder]="placeholder()"
        [type]="type()"
        [required]="required()"
        [readOnly]="readOnly()"
        [disabled]="disabled()"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.step]="step()" />
    }

    <div class="inline-content"><ng-content /></div>

    @if (pending()) {
      <dmb-inline-spinner />
    }
  </div>

  @for (warning of warnings(); track $index) {
    <span class="warning">{{ warning }}</span>
  }
  @for (error of errors(); track $index) {
    <span class="error">{{ error }}</span>
  }
</div>
